export default "<div class=\"btn-wrapper\" (click)=\"presentPopover($event)\">\n\t<div class=\"white burger-btn\" size=\"large\"></div>\n</div>\n";